// src/components/admin/AdminSidebar.js
import React, { useContext, useState } from 'react';
import {
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    IconButton,
    Box,
    Collapse,
    useTheme,
    useMediaQuery,
    Stack,
    Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import GroupIcon from '@mui/icons-material/Group';
import { useNavigate } from 'react-router-dom';
import GameonLogo from '../../assets/images/gameup_white.png';
import { UserContext } from '../../contexts/UserContext';
import { AuthContext } from '../../contexts/AuthContext';

const drawerWidth = 300;

const AdminSidebar = ({ onLogout }) => {
    const navigate = useNavigate();

    const [openSubMenus, setOpenSubMenus] = useState({});
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const theme = useTheme();
    const { clearUser } = useContext(UserContext);
    const { logout } = useContext(AuthContext);
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));

    const toggleDrawer = () => setIsDrawerOpen((prev) => !prev);
    const toggleSubMenu = (index) => {
        setOpenSubMenus((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const menuItems = [
        { label: 'Início', path: '/admin', icon: <HomeIcon /> },
        {
            label: 'Gerenciar',
            icon: <ManageAccountsIcon />,
            subItems: [
                { path: '/admin/plans', label: 'Planos' },
                { path: '/admin/contents', label: 'Missões' },
                { path: '/admin/games', label: 'Games' },
                { path: '/admin/groups', label: 'Grupos' },
                { path: '/admin/products', label: 'Produtos' },
            ],
        },
        // {
        //     label: 'Gerenciar Contas',
        //     path: '/admin/accounts',
        //     icon: <PeopleIcon />,
        // },
        // Adicione outras opções de SuperAdmin aqui
    ];

    return (
        <>
            {!isLargeScreen && (
                <Box
                    sx={{
                        width: '100%',
                        backgroundColor: '#1F83FF',
                        height: '60px',
                        padding: '10px 20px',
                    }}
                >
                    <Stack
                        direction="row"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <img
                            src={GameonLogo}
                            alt="Logo"
                            style={{
                                width: '128px',
                                height: 'auto',
                            }}
                        />
                        <IconButton color="#FFFFFF" onClick={toggleDrawer}>
                            <MenuIcon
                                sx={{
                                    color: '#FFFFFF',
                                }}
                            />
                        </IconButton>
                    </Stack>
                </Box>
            )}

            <Drawer
                variant={isLargeScreen ? 'permanent' : 'temporary'}
                open={isLargeScreen ? true : isDrawerOpen}
                onClose={toggleDrawer}
                ModalProps={{
                    keepMounted: true,
                }}
                sx={{
                    width: isLargeScreen ? drawerWidth : undefined,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        backgroundColor: theme.palette.primary.main,
                    },
                }}
            >
                <Box sx={{ width: drawerWidth }} role="presentation">
                    {isLargeScreen && (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: 15,
                            }}
                        >
                            <img
                                src={GameonLogo}
                                alt="Logo"
                                style={{
                                    width: '128px',
                                    height: 'auto',
                                }}
                            />
                        </Box>
                    )}

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            marginTop: 2,
                        }}
                    >
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Stack direction="column" alignItems="center">
                                <Typography
                                    sx={{
                                        fontSize: '14px',
                                        color: theme.palette.primary
                                            .contrastText,
                                    }}
                                >
                                    Super Admin
                                </Typography>
                            </Stack>
                        </Stack>
                    </Box>

                    <List
                        sx={{
                            mr: 4,
                            ml: 4,
                        }}
                    >
                        {menuItems.map((item, index) => (
                            <React.Fragment key={index}>
                                {!item.subItems ? (
                                    <ListItem disablePadding>
                                        <ListItemButton
                                            onClick={() => {
                                                navigate(item.path);
                                                if (!isLargeScreen) {
                                                    toggleDrawer();
                                                }
                                            }}
                                            sx={{
                                                borderRadius: '12px',
                                                backgroundColor:
                                                    window.location.pathname ===
                                                    item.path
                                                        ? theme.palette.primary
                                                              .light
                                                        : 'transparent',
                                                '&:hover': {
                                                    backgroundColor:
                                                        theme.palette.primary
                                                            .dark,
                                                },
                                                '&.Mui-selected': {
                                                    backgroundColor:
                                                        theme.palette
                                                            .blueDark[200],
                                                    '&:hover': {
                                                        backgroundColor:
                                                            theme.palette
                                                                .blueDark[100],
                                                    },
                                                },
                                            }}
                                            selected={
                                                window.location.pathname ===
                                                item.path
                                            }
                                        >
                                            <ListItemIcon
                                                sx={{
                                                    color:
                                                        window.location
                                                            .pathname ===
                                                        item.path
                                                            ? theme.palette
                                                                  .primary
                                                                  .contrastText
                                                            : theme.palette
                                                                  .primary
                                                                  .contrastText,
                                                }}
                                            >
                                                {item.icon}
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={item.label}
                                                sx={{
                                                    color:
                                                        window.location
                                                            .pathname ===
                                                        item.path
                                                            ? theme.palette
                                                                  .primary
                                                                  .contrastText
                                                            : theme.palette
                                                                  .primary
                                                                  .contrastText,
                                                }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                ) : (
                                    <>
                                        <ListItem disablePadding>
                                            <ListItemButton
                                                onClick={() =>
                                                    toggleSubMenu(index)
                                                }
                                                sx={{ borderRadius: '12px' }}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        color: theme.palette
                                                            .primary
                                                            .contrastText,
                                                    }}
                                                >
                                                    {item.icon}
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={item.label}
                                                    sx={{
                                                        color: theme.palette
                                                            .primary
                                                            .contrastText,
                                                    }}
                                                />
                                                {openSubMenus[index] ? (
                                                    <ExpandLess
                                                        sx={{
                                                            color: theme.palette
                                                                .primary
                                                                .contrastText,
                                                        }}
                                                    />
                                                ) : (
                                                    <ExpandMore
                                                        sx={{
                                                            color: theme.palette
                                                                .primary
                                                                .contrastText,
                                                        }}
                                                    />
                                                )}
                                            </ListItemButton>
                                        </ListItem>
                                        <Collapse
                                            in={openSubMenus[index]}
                                            timeout="auto"
                                            unmountOnExit
                                        >
                                            <List
                                                component="div"
                                                disablePadding
                                            >
                                                {item.subItems.map(
                                                    (subItem, subIndex) => (
                                                        <ListItem
                                                            key={subIndex}
                                                            disablePadding
                                                        >
                                                            <ListItemButton
                                                                sx={{
                                                                    pl: 4,
                                                                    borderRadius:
                                                                        '12px',
                                                                    color: theme
                                                                        .palette
                                                                        .primary
                                                                        .contrastText,
                                                                    backgroundColor:
                                                                        window
                                                                            .location
                                                                            .pathname ===
                                                                        subItem.path
                                                                            ? theme
                                                                                  .palette
                                                                                  .blueDark[200]
                                                                            : 'transparent',
                                                                    '&:hover': {
                                                                        backgroundColor:
                                                                            theme
                                                                                .palette
                                                                                .blueDark[100],
                                                                    },
                                                                }}
                                                                onClick={() => {
                                                                    navigate(
                                                                        subItem.path
                                                                    );
                                                                    if (
                                                                        !isLargeScreen
                                                                    ) {
                                                                        toggleDrawer();
                                                                    }
                                                                }}
                                                            >
                                                                <ListItemText
                                                                    primary={
                                                                        subItem.label
                                                                    }
                                                                    sx={{
                                                                        color: theme
                                                                            .palette
                                                                            .primary
                                                                            .contrastText,
                                                                    }}
                                                                />
                                                            </ListItemButton>
                                                        </ListItem>
                                                    )
                                                )}
                                            </List>
                                        </Collapse>
                                    </>
                                )}
                            </React.Fragment>
                        ))}
                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    logout();
                                    clearUser();
                                    navigate('/login');
                                }}
                                sx={{
                                    borderRadius: '12px',
                                    '&:hover': {
                                        backgroundColor:
                                            theme.palette.primary.dark,
                                    },
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        color: theme.palette.primary
                                            .contrastText,
                                    }}
                                >
                                    <ExitToAppIcon />
                                </ListItemIcon>
                                <ListItemText
                                    primary="Sair"
                                    sx={{
                                        color: theme.palette.primary
                                            .contrastText,
                                    }}
                                />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </Drawer>
        </>
    );
};

export default AdminSidebar;
